import { GlobalStyles, ThemeProvider as MuiThemeProvider } from '@mui/material'
import { ReactNode } from 'react'
import { darkTheme, globalStyles, theme } from './theme2/theme'

export const ThemeProvider = ({ children, mode = 'light' }: { children: ReactNode; mode?: 'light' | 'dark' }) => (
  <MuiThemeProvider theme={mode === 'dark' ? darkTheme : theme}>
    <GlobalStyles styles={globalStyles} />
    {children}
  </MuiThemeProvider>
)
